<template>

    <v-card class="ostalo">
        <v-card-title class="naslov-kartice">
          <span class="glif">&#9632;</span> Ostali troškovi
          <span class="smjer">ulazi u koštanje</span>
          <span class="znak">{{ items.length }} {{ mnozinaStavke }}</span>
          <v-spacer></v-spacer>
          <span class="iznos">{{ localMoney(zbrojSkupine) }}</span>
          <v-btn icon small color="primary" class="ml-2" @click="newMaterial" title="Dodaj stavku">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <!-- Unos u retku: klik na stavku puni ovaj redak za ispravak, a
             ikona u zadnjem stupcu brise. Stavka ide u store - na posluzitelj
             tek kad se spremi cijeli nalog. -->
        <div class="unos" v-if="!locked">
          <v-autocomplete ref="sifra" outlined dense hide-details="auto"
            :items="sifrarnik" v-model="novaSifra" label="Šifra / naziv"
            item-text="itemByID" item-value="itemID" :filter="sveRijeci"
            return-object clearable class="polje-sifra" @change="artiklOdabran"></v-autocomplete>
          <v-text-field outlined dense hide-details="auto" label="Naziv"
            :value="noviNaziv" readonly></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="JM"
            :value="novaMjera" readonly></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="Količina"
            v-model.number="novaKolicina" type="number" class="polje-broj"
            @keyup.enter="dodaj"></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="Cijena"
            v-model.number="novaCijena" type="number" class="polje-broj"
            @keyup.enter="dodaj"></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="Vrijednost"
            :value="localMoney(novaVrijednost)" readonly class="polje-broj"></v-text-field>
          <div class="gumbi">
            <v-btn color="primary" small :disabled="!smijeDodati" @click="dodaj">
              {{ uredujem ? 'Spremi' : 'Dodaj' }}
            </v-btn>
            <v-btn text small v-if="uredujem" @click="odustani">Odustani</v-btn>
          </div>
        </div>
        <div class="greska" v-if="greske.length">{{ greske.join(' ') }}</div>

        <v-data-table
            :headers="headers" :items="items" :search="search"
            hide-default-footer :items-per-page="-1" item-key="id" dense
            :mobile-breakpoint="0" @click:row="navigateTo">
          <template v-slot:[`item.itemPcsMinus`]="{ item }">{{ localMoney(item.itemPcsMinus) }}</template>
          <template v-slot:[`item.itemSuppPrice`]="{ item }">{{ localMoney(item.itemSuppPrice) }}</template>
          <template v-slot:[`item.itemBaseAmount`]="{ item }">{{ localMoney(item.itemBaseAmount) }}</template>
          <template v-slot:[`body.append`]>
            <tr class="zbroj-red">
              <td colspan="5" class="text-end">Ukupno</td>
              <td class="text-end">{{ localMoney(zbrojSkupine) }}</td>
            </tr>
          </template>
          <template v-slot:[`item.obrisi`]="{ item }">
            <v-icon small color="red darken-1" @click.stop="obrisi(item)"
                    title="Obriši stavku">mdi-delete-outline</v-icon>
          </template>
          <template v-slot:no-data>Ostali troškovi nisu upisani.</template>
        </v-data-table>
      </v-card>

</template>

<script>
import moneyFormat from '@/snippets/moneyFormat'
import { sveRijeci } from '@/snippets/tekst'
import { slozi, provjeri, zbrojNaloga, OSTALO } from './radniNalogZapis'

export default {
  computed: {
    sifrarnik () { return this.$store.state.itemStore ? this.$store.state.itemStore : [] },
    noviNaziv () { return this.noviArtikl ? this.noviArtikl.itemName : '' },
    novaMjera () { return this.noviArtikl ? this.noviArtikl.itemUnit : '' },
    novaVrijednost () {
      return Math.round((parseFloat(this.novaKolicina) || 0) * (parseFloat(this.novaCijena) || 0) * 100) / 100
    },
    uredujem () { return this.urediIndex >= 0 },
    smijeDodati () {
      return !!(this.noviArtikl && this.noviArtikl.itemID) && (parseFloat(this.novaKolicina) || 0) !== 0
    },
    // Jezik se cita jednom, a ne u svakom stupcu posebno.
    en () {
      return this.$store.state.language === 'EN'
    },
    // Zbroj skupine stoji u naslovu - prije se vidio tek u financijskoj
    // kartici, nakon sto se prolista cijela tablica.
    zbrojSkupine () {
      return (this.items || []).reduce((z, s) => z + (parseFloat(s.itemBaseAmount) || 0), 0)
    },
    mnozinaStavke () {
      const n = (this.items || []).length
      return n === 1 ? 'stavka' : (n >= 2 && n <= 4 ? 'stavke' : 'stavaka')
    }
  },
  name: 'documentdetaillist3',
  data () {
    return {
      msg: '',
      items: [],
      locked: false,
      novaSifra: null,
      noviArtikl: null,
      novaKolicina: null,
      novaCijena: null,
      greske: [],
      urediIndex: -1,
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: '',
        databaseDocID: 0,
        FreeF1: 3
      }
    }
  },
  async mounted () {
    try {
      if (this.$store.state.companyid) {
        this.mainQuery.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        this.mainQuery.businessYear = this.$store.state.businessYear
      }
      if (this.$store.state.documentActiv) {
        this.mainQuery.documentName = this.$store.state.documentActiv
      }
      if (this.$store.state.databaseDocID) {
        this.mainQuery.databaseDocID = this.$store.state.databaseDocID
      }
      this.locked = this.$store.state.documentActivHead &&
        this.$store.state.documentActivHead.documentLocked === true
      this.mainQuery.FreeF1 = 3
      this.items = this.$store.state.documentActivItems.filter(item => {
            return parseInt(item.FreeF6)  === 32
          })
      // Ostali trosak nije skladisni promet, pa kolicina nema predznak.
      this.headers = [
        { text: this.en ? 'Code' : 'Šifra', align: 'start', value: 'itemID', width: '110px' },
        { text: this.en ? 'Name' : 'Naziv', align: 'start', value: 'itemName' },
        { text: this.en ? 'Unit' : 'JM', align: 'start', value: 'itemUnit', width: '60px' },
        { text: this.en ? 'Qty' : 'Količina', align: 'end', value: 'itemPcsMinus', width: '120px' },
        { text: this.en ? 'Price' : 'Cijena', align: 'end', value: 'itemSuppPrice', width: '120px' },
        { text: this.en ? 'Value' : 'Vrijednost', align: 'end', value: 'itemBaseAmount', width: '130px' },
        { text: '', value: 'obrisi', align: 'center', sortable: false, width: '48px' }
      ]
    } catch (error) {
      // eslint-disable-next-line
      console.log(error)
    }
  },
  methods: {
    sveRijeci,
    artiklOdabran () {
      this.greske = []
      this.noviArtikl = this.novaSifra && this.novaSifra.itemID
        ? this.sifrarnik.find(a => a.itemID === this.novaSifra.itemID) : null
      if (this.noviArtikl) {
        this.novaCijena = parseFloat(this.noviArtikl.itemSuppPrice) || null
      }
    },
    dodaj () {
      const podaci = {
        skupina: OSTALO,
        glava: this.$store.state.documentActivHead || {},
        artikl: this.noviArtikl,
        kolicina: this.novaKolicina,
        cijena: this.novaCijena,
        databaseDocID: this.$store.state.databaseDocID,
        korisnik: this.$store.state.user ? this.$store.state.user.email : ''
      }
      this.greske = provjeri(podaci)
      if (this.greske.length) { return }
      const stavke = (this.$store.state.documentActivItems || []).slice()
      const nova = slozi(podaci)
      if (this.urediIndex >= 0) {
        nova.id = stavke[this.urediIndex] ? stavke[this.urediIndex].id : undefined
        stavke.splice(this.urediIndex, 1, nova)
      } else {
        stavke.push(nova)
      }
      this.spremiUStore(stavke)
      this.ocisti()
      this.$nextTick(() => { if (this.$refs.sifra) { this.$refs.sifra.focus() } })
    },
    spremiUStore (stavke) {
      this.$store.dispatch('setDocumentActivItems', stavke)
      const glava = Object.assign({}, this.$store.state.documentActivHead, zbrojNaloga(stavke))
      this.$store.dispatch('setDocumentActivHead', glava)
      this.osvjezi()
    },
    ocisti () {
      this.novaSifra = null
      this.noviArtikl = null
      this.novaKolicina = null
      this.novaCijena = null
      this.urediIndex = -1
      this.greske = []
    },
    odustani () { this.ocisti() },
    obrisi (item) {
      if (this.locked) { return }
      const opis = ((item.itemID || '') + ' ' + (item.itemName || '')).trim()
      if (!confirm('Obrisati stavku ' + opis + '?')) { return }
      const stavke = (this.$store.state.documentActivItems || []).slice()
      const i = stavke.indexOf(item)
      if (i === -1) { return }
      stavke.splice(i, 1)
      this.spremiUStore(stavke)
      if (this.urediIndex === i) { this.ocisti() }
    },
    osvjezi () {
      this.items = (this.$store.state.documentActivItems || []).filter(item => {
        return parseInt(item.FreeF6) === 32
      })
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    // Klik na stavku puni gornji redak - ispravak na istom mjestu gdje se unosi.
    navigateTo (item) {
      if (this.locked) { return }
      this.greske = []
      this.urediIndex = (this.$store.state.documentActivItems || []).indexOf(item)
      this.noviArtikl = this.sifrarnik.find(a => a.itemID === item.itemID) || {
        itemID: item.itemID, itemName: item.itemName, itemUnit: item.itemUnit,
        itemVAT1Percentage: item.itemVAT1Percentage
      }
      this.novaSifra = {itemID: item.itemID, itemByID: item.itemID + ' ' + (item.itemName || '')}
      this.novaKolicina = parseFloat(item.itemPcsMinus) || 0
      this.novaCijena = parseFloat(item.itemSuppPrice) || 0
    },
    newMaterial () {
      this.$store.dispatch('seteditItem', 0)
      this.$store.dispatch('settypePOS', 32)
      // warehouse minus
      this.$store.dispatch('setDocumentSide', 2) 
      this.$router.push({
        name: 'documentdetailcreateedit3'
      })
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Naslov skupine. "v-card-title" je flex spremnik, pa razmaci izmedu elemenata
   nestaju - svaki razmak mora doci iz margine, inace se tekst slijepi
   ("materijala- razduzuje skladiste14 stavaka").
   Boja NIJE jedini znak skupine: uz nju idu glif i rijec, pa se razlika vidi i
   na crno-bijelom ispisu. */
.naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 14px;
  min-height: 0;
  flex-wrap: nowrap;
}
.naslov-kartice .glif { margin-right: 8px; font-size: 15px; line-height: 1; }
.naslov-kartice .smjer {
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  padding: 2px 9px;
  border-radius: 10px;
  margin-left: 12px;
  white-space: nowrap;
}
.naslov-kartice .znak {
  font-size: 13px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  margin-left: 12px;
  white-space: nowrap;
}
.naslov-kartice .iznos {
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  margin-left: 12px;
}
.utroseno .naslov-kartice { color: #8a4b00; background: #fff8f0; border-bottom-color: #ef6c00; }
.utroseno .naslov-kartice .smjer { background: #ffe0b2; color: #8a4b00; }
.rad .naslov-kartice { color: #4527a0; background: #f5f3fb; border-bottom-color: #5e35b1; }
.rad .naslov-kartice .smjer { background: #ede7f6; color: #4527a0; }
.ostalo .naslov-kartice { color: #0d47a1; background: #eef4fb; border-bottom-color: #1976d2; }
.ostalo .naslov-kartice .smjer { background: #e3f2fd; color: #0d47a1; }
.proizvedeno .naslov-kartice { color: #1b5e20; background: #f1f8f1; border-bottom-color: #43a047; }
.proizvedeno .naslov-kartice .smjer { background: #c8e6c9; color: #1b5e20; }
.kol { font-weight: 600; }
.dobit { font-weight: 600; color: #1b5e20; }
.zbroj-red td {
  font-weight: 700;
  border-top: 2px solid #e0e0e0;
  background: #fafafa;
  font-variant-numeric: tabular-nums;
}
.unos {
  display: grid;
  grid-template-columns: 190px 1fr 70px 110px 130px 130px auto;
  gap: 8px;
  align-items: center;
  padding: 10px 14px;
  background: #eef4fb;
  border-bottom: 1px solid #e0e0e0;
}
.unos .polje-broj >>> input { text-align: right; }
.unos .gumbi { display: flex; gap: 4px; align-items: center; }
.greska { padding: 6px 14px; color: #c62828; font-size: 13px; }
@media (max-width: 1100px) { .unos { grid-template-columns: 1fr 1fr; } }
</style>
